import React, { useState, useEffect } from "react";

// const data = [
//   {
//     question:
//       "How To Select Design, Give Order, Download Design, Add Wallet Balance, Join In Telegram Group?",
//     // video: "https://www.youtube.com/embed/vJdVKWLsFO8",
//     video: "https://www.youtube.com/watch?v=RLYaHIkMgvY",
//   },
//   {
//     question: "How To Download EMB Design Into PC?",
//     image: "/images/howto/02-download-design.jpg",
//   },
//   {
//     question: "How To Add Balance In Wallet?",
//     imageGroup: [
//       "/images/howto/03-1-add-wallet-balance.jpg",
//       "/images/howto/03-2.jpg",
//       "/images/howto/03-3.jpg",
//     ],
//   },
//   {
//     question: "How I Can Join LTC Telegram Group?",
//     image: "/images/howto/04-join-telegram-group.jpg",
//   },
//   {
//     question: "How To Do Zip To UnZip EMB File?",
//     video: "https://www.youtube.com/embed/dpjZE_ZN3p4",
//   },
//   {
//     question: "How To Download WinZip Software?",
//     image: "/images/howto/05-download-zip-software.jpg",
//   },
// ];
const data = [
  {
    question:
      "How To Select Design, Give Order, Download Design, Add Wallet Balance, Join In Telegram Group?",
    video: "https://www.youtube.com/embed/RLYaHIkMgvY",
  },
  {
    question: "How To Download EMB Design Into PC?",
    image: "/images/howto/02-download-design.jpg",
  },
  {
    question: "How To Add Balance In Wallet?",
    imageGroup: [
      "/images/howto/03-1-add-wallet-balance.jpg",
      "/images/howto/03-2.jpg",
      "/images/howto/03-3.jpg",
    ],
  },
  {
    question: "How I Can Join LTC Telegram Group?",
    image: "/images/howto/04-join-telegram-group.jpg",
  },
  {
    question: "How To Do Zip To UnZip EMB File?",

    video: "https://www.youtube.com/embed/Ddh73hKUoyI",
  },
  {
    question: "How To Download WinZip Software?",
    image: "/images/howto/05-download-zip-software.jpg",
  },
];

export default function Howtouse() {
  useEffect(() => {
    document.title = "How It Works";
  }, []);
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "How to Use",
      link: "/how-to-use",
    },
  ];

  return (
    <div style={styles.page}>
      <div className="container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {breadcrumbItems.map((item, i) => (
              <li
                key={i}
                className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
              >
                {i === breadcrumbItems.length - 1 ? (
                  item.label
                ) : (
                  <a href={item.link}>{item.label}</a>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
      <div style={styles.wrapper}>
        <h2 style={styles.title}>How It Works</h2>
        <p style={styles.subtitle}>
          Step-by-step guide to use our platform easily
        </p>

        <div style={styles.accordion}>
          {data.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                style={{
                  ...styles.card,
                  ...(isOpen ? styles.cardActive : {}),
                }}
              >
                {/* HEADER */}
                <div style={styles.question} onClick={() => toggle(index)}>
                  <span>{item.question}</span>

                  <span
                    style={{
                      ...styles.icon,
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                    }}
                  >
                    +
                  </span>
                </div>

                {/* CONTENT */}
                <div
                  style={{
                    ...styles.answer,
                    display: isOpen ? "block" : "none",
                    padding: isOpen ? "15px" : "0px 15px",
                  }}
                >
                  {isOpen && (
                    <>
                      {/* VIDEO */}
                      {item.video && (
                        <div style={styles.videoWrapper} className="res-style">
                          <iframe
                            src={item.video}
                            title="tutorial"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={styles.video}
                          />
                        </div>
                      )}
                      {/* SINGLE IMAGE */}
                      {item.image && (
                        <img
                          src={item.image}
                          alt="guide"
                          style={styles.image}
                          onError={(e) => {
                            e.target.src = "/images/no-image.png";
                          }}
                          className="res-style"
                        />
                      )}

                      {/* MULTIPLE IMAGES (PHP like row layout converted) */}
                      {item.imageGroup && (
                        <div style={styles.grid}>
                          {item.imageGroup.map((img, i) => (
                            <img
                              key={i}
                              src={img}
                              alt="guide"
                              style={styles.gridImage}
                              onError={(e) => {
                                e.target.src = "/images/no-image.png";
                              }}
                              className="res-group"
                            />
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */
const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f6f8fc, #eef2f7)",
    padding: "20px 15px",
  },

  wrapper: {
    maxWidth: "1600px",
    margin: "0 auto",
  },

  title: {
    textAlign: "center",
    fontSize: "32px",
    fontWeight: "800",
    color: "#222",
  },

  subtitle: {
    textAlign: "center",
    color: "#666",
    marginBottom: "25px",
    fontSize: "14px",
  },

  accordion: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },

  card: {
    background: "#fff",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 3px 15px rgba(0,0,0,0.06)",
    transition: "0.3s",
  },

  cardActive: {
    boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
  },

  question: {
    padding: "18px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: "600",
    background: "#fff",
  },

  icon: {
    fontSize: "22px",
    fontWeight: "bold",
    transition: "0.3s",
  },

  answer: {
    overflow: "hidden",
    transition: "all 0.3s ease",
  },

  image: {
    width: "100%",
    borderRadius: "10px",
    marginTop: "10px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
    marginTop: "10px",
  },

  gridImage: {
    width: "100%",
    borderRadius: "10px",
  },

  videoWrapper: {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%",
    borderRadius: "10px",
    overflow: "hidden",
  },

  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
};
